import React from 'react';
import { formatMoney } from '@src/utils';

const index = ({ amount, duration }: { amount: number; duration: number }) => {
  const payoutAmount = (duration === 60 ? amount : amount / 2) as number;
  return <div>{payoutAmount < 0 ? '$0' : formatMoney(payoutAmount)}</div>;
};

export default index;
